import React from 'react'; 
import mData from '../hybriddata/mainform.json';
import { Field } from '@progress/kendo-react-form';
import {  HybridFormLabelGrey, HybridFormLabelGreyTooltip } from '../validation/Form-Components';
import config from '../appconfig/config.json';

const TenureSelection = (props) => {
    
    const { monthlyInstallment1, monthlyInstallment2,monthlyInstallment3,monthlyInstallment4,monthlyInstallment5, selectedTenureCard,setSelectedTenureCard}= props
 
    return(
        <div>
            {config.UseFixedInterestRate? 
            <Field component={HybridFormLabelGreyTooltip} 
                id={'fstTenure'} name={'Select your preferred financing term / Estimated Monthly Instalment'}
                tooltipPosition={'right'} tooltipAchor={'target'} 
                tooltipTitle={mData.interestRateTooltip}/>  
                :
            <Field component={HybridFormLabelGrey} 
                labelId={'fstTenure'} labelName={'Select your preferred financing term / Estimated Monthly Instalment'} />
            }
            <div className="m-scroll-row inputPair prefFinanceFontSize m-full-wdt">
                <div className="t-col-wdt m-mar-btm">
                    <div className={(props.selectedTenureCard.tenure === mData.tenureType.t1)?'yellowbox':'tenurebox greybox'}
                        onClick={(e)=> {
                            e.preventDefault();
                            const tCard = {
                                tenure: mData.tenureType.t1,
                                estMonthlyInstallment: monthlyInstallment1
                            }
                            props.setSelectedTenureCard(tCard);
                            props.onSelect(tCard);
                        }}>
                        <div className='mDgrayLbl'>1 year</div>
                        <div>
                            <span className='prefFinanceTitle'>{'S$ '+ monthlyInstallment1}</span>
                            <div className='m-greyLabel'>per month</div>
                        </div>
                    </div>
                </div>
                <div className="t-col-wdt m-mar-btm">
                    <div className={(props.selectedTenureCard.tenure === mData.tenureType.t2)?'yellowbox':'tenurebox greybox'}
                        onClick={(e)=> {
                            e.preventDefault();
                            const tCard = {
                                tenure: mData.tenureType.t2,
                                estMonthlyInstallment: monthlyInstallment2
                            }
                            props.setSelectedTenureCard(tCard);
                            props.onSelect(tCard);
                        }}>
                        <div className='mDgrayLbl'>2 years</div>
                        <div>
                            <span className='prefFinanceTitle'>{'S$ '+ monthlyInstallment2}</span>
                            <div className='m-greyLabel'>per month</div>
                        </div>
                    </div>
                </div>
                <div className="t-col-wdt">
                    <div className={(props.selectedTenureCard.tenure === mData.tenureType.t3)?'yellowbox':'tenurebox greybox'}
                     onClick={(e)=> {
                            e.preventDefault();
                            const tCard = {
                                tenure: mData.tenureType.t3,
                                estMonthlyInstallment: monthlyInstallment3
                            }
                            props.setSelectedTenureCard(tCard);
                            props.onSelect(tCard);
                        }}>
                        <div className='mDgrayLbl'>3 years</div>
                        <div>
                            <span className='prefFinanceTitle'>{'S$ '+ monthlyInstallment3}</span>
                            <div className='m-greyLabel'>per month</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="m-scroll-row inputPair prefFinanceFontSize m-full-wdt">
                <div className="t-col-wdt m-mar-btm">
                    <div className={(props.selectedTenureCard.tenure === mData.tenureType.t4)?'yellowbox':'tenurebox greybox'}
                        onClick={(e)=> {
                            e.preventDefault();
                            const tCard = {
                                tenure: mData.tenureType.t4,
                                estMonthlyInstallment: monthlyInstallment4
                            }
                            props.setSelectedTenureCard(tCard);
                            props.onSelect(tCard);
                        }}>
                        <div className='mDgrayLbl'>4 years</div>
                        <div>
                        <span className='prefFinanceTitle'>{'S$ '+ monthlyInstallment4}</span>
                        <div className='m-greyLabel'>per month</div>
                        </div>
                    </div>
                </div>
                <div className="t-col-wdt m-mar-btm">
                    <div className={(props.selectedTenureCard.tenure === mData.tenureType.t5)?'yellowbox':'tenurebox greybox'}
                        onClick={(e)=> {
                            e.preventDefault();
                            const tCard = {
                                tenure: mData.tenureType.t5,
                                estMonthlyInstallment: monthlyInstallment5
                            }
                            props.setSelectedTenureCard(tCard);
                            props.onSelect(tCard);
                        }}>
                    <div className='mDgrayLbl'>5 years</div>
                        <span className='prefFinanceTitle'>{'S$ '+ monthlyInstallment5}</span>
                        <div className='m-greyLabel'>per month</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TenureSelection;